import { StoreProvider } from './storeComposer'
import { useStore } from './useStore'

export { StoreProvider, useStore }
export default useStore
